import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { useGLTF } from "@react-three/drei";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import LoadingSpinner from "../loader/loader";

function Model({ onLoaded, ...props }) {
  const { scene } = useGLTF("/car.glb");

  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  isMobile ? scene.scale.set(2.5, 2.5, 2.5) : scene.scale.set(3.5, 3.5, 3.5);

  useFrame(() => {
    scene.rotation.y += 0.004; // Adjust the rotation speed by changing the value (e.g., 0.01)
  });

  useEffect(() => {
    if (scene) onLoaded?.();
  }, [scene, onLoaded]);

  return <primitive object={scene} {...props} />;
}

export default function ModelViewer() {
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  const handleLoaded = () => {
    setLoading(false);
  };
  return (
    <>
      {loading && (
        <div className="loading-container">
          {" "}
          <LoadingSpinner />{" "}
        </div>
      )}
      <Canvas
        gl={{ preserveDrawingBuffer: false }}
        style={{
          width: "100%",
          height: isMobile ? "400px" : "100%",
        }}
      >
        <ambientLight intensity={0.9} />

        <directionalLight position={[0, 10, 10]} />
        <directionalLight position={[10, 10, 10]} />
        <PerspectiveCamera makeDefault position={[-10, 2, 10]} />
        <OrbitControls
          target={[0, 0, 0]}
          position={[0, 0, 0]}
          enableZoom={false}
        />
        {isMobile ? (
          <Model onLoaded={() => handleLoaded()} position={[0, -8, 0]} />
        ) : (
          <Model onLoaded={() => handleLoaded()} position={[0, -13, 0]} />
        )}
      </Canvas>
    </>
  );
}
